function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ICON-New-Star",
  transform: "translate(2.000000, 3.000000)",
  fill: "#B0B3B6",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M13.602,5.041 L10,-2.25955146 L6.397,5.041 L-1.6595263,6.21159025 L4.17,11.894 L2.79401645,19.9181855 L10,16.13 L17.2059835,19.9181855 L15.829,11.894 L21.6595263,6.21159025 L13.602,5.041 Z M7.72513925,6.86892279 L10,2.258 L12.2748607,6.86892279 L17.361,7.608 L13.680802,11.1959651 L14.549,16.262 L10,13.8702243 L5.45,16.262 L6.31919799,11.1959651 L2.638,7.608 L7.72513925,6.86892279 Z",
  id: "Grey-Star_Results"
})));

var SvgStarGrey = function SvgStarGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "star-grey",
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStarGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star_grey.53ecbeef.svg";
export { ForwardRef as ReactComponent };